"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.App = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reactRedux = require("react-redux");

var _MapPanel = _interopRequireDefault(require("./containers/MapPanel"));

var _InfoBox = _interopRequireDefault(require("./containers/InfoBox"));

var _MenuHeader = _interopRequireDefault(require("./containers/MenuHeader"));

var _MenuPanel = _interopRequireDefault(require("./containers/MenuPanel"));

var _MessageDialog = _interopRequireDefault(require("./containers/MessageDialog"));

var _MapControl = _interopRequireDefault(require("./containers/MapControl"));

var _BreakpointService = require("./modules/BreakpointService");

var _mapActions = require("./actions/mapActions");

var _SplashScreen = _interopRequireDefault(require("./containers/SplashScreen"));

var _MobileInfoBox = _interopRequireDefault(require("./containers/MobileInfoBox"));

var _MapTypeToggle = _interopRequireDefault(require("./containers/MapTypeToggle"));

var _sc = require("./actions/sc4");

var _permissions = require("./config/permissions");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import MobileInfoBox from './containers/MobileInfoBox';


var App = function App(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var userType = props.userType,
      userMuniCounty = props.userMuniCounty;

  var onResize = _lodash.default.debounce(function () {
    var appDOMContainer = window.document.getElementById('kubra-custom-app');
    var appWidth = appDOMContainer && appDOMContainer.offsetWidth || window.innerWidth;
    var breakpoint = (0, _BreakpointService.getNameByPixels)(appWidth);

    if (breakpoint) {
      dispatch({
        type: _mapActions.DEVICE_CHANGED,
        nextDevice: breakpoint
      });
    }
  }, 10);

  (0, _react.useEffect)(function () {
    dispatch((0, _sc.resetMetadataDirectory)());
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', onResize);
    onResize();
    return function () {
      window.removeEventListener('resize', onResize);
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "loadshed-map-app"
  }, /*#__PURE__*/_react.default.createElement(_MapPanel.default, {
    initialMapLocation: props.initialMapLocation,
    userType: userType,
    userMuniCounty: userMuniCounty || _permissions.DEFAULT_COUNTY_MUNI
  }), /*#__PURE__*/_react.default.createElement(_MenuHeader.default, null), /*#__PURE__*/_react.default.createElement(_MenuPanel.default, {
    userType: userType
  }), /*#__PURE__*/_react.default.createElement(_MapControl.default, null), /*#__PURE__*/_react.default.createElement(_InfoBox.default, null), /*#__PURE__*/_react.default.createElement(_MobileInfoBox.default, null), /*#__PURE__*/_react.default.createElement(_MessageDialog.default, null), /*#__PURE__*/_react.default.createElement(_SplashScreen.default, null), /*#__PURE__*/_react.default.createElement(_MapTypeToggle.default, null));
};

exports.App = App;
App.propTypes = {
  initialMapLocation: _propTypes.default.string,
  userMuniCounty: _propTypes.default.string,
  userType: _propTypes.default.any.isRequired
};
var _default = App;
exports.default = _default;